import _keyBy from 'lodash/keyBy';

import {
  getAddresses,
  getUserAttributeValues,
  updateUserAttributeValue,
} from '@homeservices/api-kit/security/users';

const SMS_NOTIFICATIONS = {
  ENABLED: '0',
  DISABLED: '1',
};

export default {
  namespaced: true,
  state () {
    return {
      userAddresses: {},
      userAttributeValues: {},
      userContacts: {},
    };
  },
  getters: {
    zipcode ({ userAddresses }) {
      const addr = userAddresses.HOME;
      return addr.zipcode;
    },
    address ({ userAddresses }) {
      const addr = userAddresses.HOME;
      return addr ? `${addr.address_line1}, ${addr.city}, ${addr.state} ${addr.zipcode}` : '';
    },
    email ({ userContacts }) {
      return userContacts.email && userContacts.email.contact;
    },
    website ({ userContacts }) {
      return userContacts.website && userContacts.website.contact;
    },
    phone ({ userContacts }) {
      return userContacts.phone && userContacts.phone.contact;
    },
    sms ({ userContacts }) {
      return userContacts.text && userContacts.text.contact;
    },
    smsNotificationEnabled ({ userAttributeValues }) {
      const smsAttr = userAttributeValues.sms_disabled;
      return smsAttr && smsAttr.user_attribute_value === SMS_NOTIFICATIONS.ENABLED;
    },
    businessName (state, getters, rootState, rootGetters) {
      const { serviceProviders } = rootState.account.pro;
      const serviceProvidersIds = rootGetters['account/pro/serviceProvidersIds'];
      const serviceProvider = serviceProviders[serviceProvidersIds[0]];
      return serviceProvider && serviceProvider.business_name;
    },
    proXtraNumber (state, getters, rootState) {
      const { serviceProviderAttributeValues } = rootState.account.pro;
      return serviceProviderAttributeValues.proxtra_number
          && serviceProviderAttributeValues.proxtra_number.value;
    },
    serviceProviderId (state, getters, rootState, rootGetters) {
      const serviceProvidersIds = rootGetters['account/pro/serviceProvidersIds'];
      return serviceProvidersIds[0];
    },
  },
  actions: {
    async fetch ({ dispatch }) {
      await Promise.all([
        dispatch('fetchUserAddresses'),
        dispatch('fetchUserAttributeValues'),
      ]);
    },
    async fetchUserAddresses ({ commit, rootGetters }) {
      const { data } = await getAddresses({ user_ids: rootGetters['user/userId'] });
      commit('setUserAddresses', _keyBy(data.results, 'address_type'));
    },
    async fetchUserAttributeValues ({ commit, rootGetters }) {
      const { data } = await getUserAttributeValues({ user_ids: rootGetters['user/userId'] });
      commit('setUserAttributeValues', _keyBy(data.results, 'user_attribute'));
    },
    async updateSmsNotification ({ commit, rootGetters }, value) {
      const smsValue = SMS_NOTIFICATIONS[value ? 'ENABLED' : 'DISABLED'];
      commit('setSmsNotification', smsValue); // Set the sms value (assume API success)
      try {
        await updateUserAttributeValue({
          user_id: rootGetters['user/userId'],
          user_attribute: 'sms_disabled',
          user_attribute_value: smsValue,
          lifecycle_status: 'active',
        });
      } catch (err) {
        // Reset the sms value if the request fails
        commit('setSmsNotification', SMS_NOTIFICATIONS[smsValue === SMS_NOTIFICATIONS.ENABLED ? 'DISABLED' : 'ENABLED']);
      }
    },
  },
  mutations: {
    setUserAddresses (state, data) {
      state.userAddresses = data;
    },
    setUserAttributeValues (state, data) {
      state.userAttributeValues = data;
    },
    setUserContacts (state, data) {
      state.userContacts = data;
    },
    setSmsNotification (state, value) {
      // Update if sms value it exists
      if (state.userAttributeValues.sms_disabled) {
        state.userAttributeValues.sms_disabled.user_attribute_value = value;
      } else {
        // Create sms value if it does not exist
        state.userAttributeValues.sms_disabled = {
          user_attribute_value: value,
        };
      }
    },
  },
};
